import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import Item from './Item';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle, faCalendar } from "@fortawesome/free-solid-svg-icons";
import { formatItemDate } from '../helpers';
import DelivItem from './DelivItem';

const DeliverableMain = styled.div`
							@media (max-width: 991px) {
								padding-top:100px;
								.mobile-title{
									text-align:center;
									margin-bottom:6px;
								}
							}
							.category-outer{
								background: #F5F5F5;
								padding: 20px 40px;
								margin: 20px auto;
							}
							.cat-border{
								border-top:solid 1px #dfdfdf;
								padding-top:15px;
								@media (max-width: 991px) {
									border-top:0px;
								}
							}
							.title{
								color:#000;
                                font-size:14px;
                                font-weight:bold;
                            }
                            .title-box{
                                width:95%;
                                padding:5px;
                                background: #fff;
                            }
                            .mobile-title{
                                padding-right:25px;
                            }
                            .title-box-left{
                                color:#999;
                                float:left;
                                width:80%;
                                padding-top:5px;
                                span{
                                    padding-left:5px;
                                }
                            }
                            .title-box-right{
                                color:#999;
                                float:left;
                                padding-top:5px;
                                font-size:18px;
                            }
                            .clear{
                                clear:both;
                            }
							
`;


const DeliverableItems = (props) => {

    return (
        <DeliverableMain>
            {props.dept && props.dept ? props.deliverables.filter(deliverable => deliverable.dept === props.dept.slug).map((deliverable, index) => (
                props.activityItems.filter(activity => (activity.dept === props.dept.slug) && (activity.deliverable === deliverable.key)).length !== 0 ?
                    <section key={index}>
                        <div className="row">
                            <div className="col-12">
                                <div className="cat-border"></div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12 col-md-2 mobile-title">
                                <DelivItem deliverable={deliverable} />
                            </div>
                            <div className="col-sm-12 col-md-8 px-0">
                                <div className="row">
                                    <div className="col-12 px-0">
                                        <div className="row">
                                            {props.activityItems.filter(activity => (activity.dept === props.dept.slug) && (activity.deliverable === deliverable.key)).map((item, index) => (
                                                <div className="col-sm-12 col-md-3 px-2" key={index}>
                                                    <Item item={item} />
                                                </div>
                                            )
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-2">

                            </div>
                        </div>
                    </section>
                    : ''
            )
            ) : ''}
        </DeliverableMain>
    );
}

export default DeliverableItems;